import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';
import FormFieldHint from './FormFieldHint';

/**
 * Top-aligned field label — Stripe/Linear-style admin forms (no floating notch labels).
 */
export default function FormFieldLabel({
  label,
  required = false,
  htmlFor,
  id,
  hint,
  sx = {},
}) {
  const { semantic, typography } = useFeatureTheme();

  if (!label) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 0.75,
        minHeight: 20,
        ...sx,
      }}
    >
      <Typography
        id={id}
        component="label"
        htmlFor={htmlFor}
        sx={{
          fontSize: typography.fontSizeSm,
          fontWeight: typography.fontWeightMedium,
          lineHeight: 1.4,
          letterSpacing: '0.01em',
          color: semantic.text.primary,
          cursor: htmlFor ? 'pointer' : 'default',
        }}
      >
        {label}
        {required ? (
          <Box
            component="span"
            aria-hidden="true"
            sx={{ color: semantic.states.danger, ml: 0.25 }}
          >
            *
          </Box>
        ) : null}
      </Typography>
      {hint ? <FormFieldHint title={hint} /> : null}
    </Box>
  );
}
